// 动态导入，避免将 mixpanel 打入首屏包
let mixpanel: typeof import('mixpanel-browser') | null = null;

const MIXPANEL_TOKEN = '6cf7aca875a51614cbb35d153693746e';
const IS_PRODUCTION = import.meta.env.PROD;

export type MixpanelEvent = 'sign_up' | 'sign_in' | 'page_view';

export const maskData = (data: string | undefined, type: 'phone' | 'name'): string | undefined => {
  if (!data) return data;

  if (type === 'phone') {
    // 电话号码脱敏：保留前3位和后4位，中间用*替换
    if (data.length >= 7) {
      const prefix = data.substring(0, 3);
      const suffix = data.substring(data.length - 4);
      const masked = '*'.repeat(data.length - 7);
      return `${prefix}${masked}${suffix}`;
    }
    // 如果长度不足7位，只保留首尾各1位
    if (data.length >= 2) {
      return `${data[0]}${'*'.repeat(data.length - 2)}${data[data.length - 1]}`;
    }
    return data;
  }

  if (type === 'name') {
    if (data.length === 1) {
      return data;
    }
    if (data.length === 2) {
      return `${data[0]}*`;
    }
    const first = data[0];
    const last = data[data.length - 1];
    const middle = '*'.repeat(data.length - 2);
    return `${first}${middle}${last}`;
  }

  return data;
};

// 初始化
export const initMixpanel = async () => {
  if (!IS_PRODUCTION || !MIXPANEL_TOKEN) {
    return;
  }

  if (!mixpanel) {
    mixpanel = (await import('mixpanel-browser')).default as any;
  }

  mixpanel!.init(MIXPANEL_TOKEN, {
    debug: import.meta.env.DEV, // 开发环境显示调试信息
    track_pageview: true, // 自动追踪页面访问
    persistence: 'localStorage', // 使用 localStorage 存储用户数据
  });
};

// 追踪事件
export const trackEvent = (
  event: MixpanelEvent,
  properties: Record<string, any>,
  callback?: () => void,
) => {
  if (!IS_PRODUCTION) {
    callback?.();
    return;
  }
  mixpanel?.track?.(
    event,
    {
      ...properties,
      timestamp: new Date().toISOString(),
    },
    callback,
  );
};

// 设置用户身份（登录后调用）
export const identifyUser = (userInfo: {
  agentId: number;
  name?: string;
  telephone?: string;
  avatar?: string;
  entId?: number;
}) => {
  if (!IS_PRODUCTION) return;

  mixpanel?.identify?.(String(userInfo.agentId));
  mixpanel?.people?.set?.({
    $name: maskData(userInfo.name, 'name'),
    $phone: maskData(userInfo.telephone, 'phone'),
    $avatar: userInfo.avatar,
    user_id: userInfo.agentId,
    ent_id: userInfo.entId,
    signup_time: new Date().toISOString(),
  });
};

// 重置用户身份（登出后调用）
export const resetUser = () => {
  if (!IS_PRODUCTION) return;

  mixpanel?.reset?.();
};
